import {convertEmployeeRateDates} from "./employeeRateAudit";
import {RREmployeePPH} from "../../types/RREmployeeType";

export const employeesFBConverter = {
    toFirestore: (employee: any) => {
        return {
            department: employee.department,
            egn: employee.egn,
            name: employee.name,
            email: employee.email,
            phone: employee.phone,
            startDate: employee.startDate,
            leaveDate: employee.leaveDate,
            empl_pph: employee.empl_pph,
            pph: employee.pph,
            supervisor_pph: employee.supervisor_pph,
            isDeleted: employee.isDeleted,
            password: employee.password,
            isSuperAdmin: employee.isSuperAdmin,
            isAdmin: employee.isAdmin,
            isEmployee: employee.isEmployee,
            isCatering: employee.isCatering,
            isStore: employee.isStore,
            isMontage: employee.isMontage,
            isLogistics: employee.isLogistics,
            canSeePayment: employee.canSeePayment,
            canSeeLogisticsScheduleReport: employee.canSeeLogisticsScheduleReport,
            canUseMobileApp: employee.canUseMobileApp,
            canUseWebApp: employee.canUseWebApp,
            listIndex_montage: employee.listIndex_montage,
            listIndex_catering: employee.listIndex_catering,
            listIndex_store: employee.listIndex_store,
            listIndex_logistics: employee.listIndex_logistics
        };
    },
    fromFirestore: (snapshot: any, options: any) => {
        const data = snapshot.data(options);
        return {
            id: snapshot.id,
            ...data,
            startDate: data.startDate.toDate(),
            leaveDate: data.leaveDate ? data.leaveDate.toDate() : null,
            empl_pph: (data.empl_pph || []).map(
                (rate: RREmployeePPH) => convertEmployeeRateDates(rate)
            ),
        };
    }
}
